module.exports = __webpack_public_path__ + "static/privacy-5e4340aa43419b61d6126066d2c279c6.png";